import analyticsTracker from '../services/analyticsTracker';

export default store => next => action => {
	const analytics = action.analytics;

	if (typeof analytics !== 'undefined' && analytics !== null) {
		const events = Array.isArray(analytics) ? analytics : [analytics];
		events.forEach(item => {
			const { event, data, platform, isCustomEvent, eventId } = item;
			analyticsTracker.trackEvent(event, data, platform, isCustomEvent, eventId);
		});
	}

	return next(action);
};
